import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { DialogLayoutComponent } from "@obg/mat.ui.core";
import { SessionLimitRequiredService } from "@obg/ngx.core";
import { Subscription } from "rxjs";
import { filter, tap } from "rxjs/operators";

@Component({
	selector: "obg-m-sga-session-limit-dialog",
	styleUrls: ["./sga-session-limit-dialog.container.scss"],
	templateUrl: "./sga-session-limit-dialog.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SgaSessionLimitDialogContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-sga-session-limit-dialog") hostCssClass = true;
	@ViewChild("dialog") dialogLayout!: DialogLayoutComponent;

	private data$$: Subscription | undefined;

	constructor(private sessionLimitRequiredService: SessionLimitRequiredService) {}

	ngOnInit() {
		this.data$$ = this.sessionLimitRequiredService
			.isSessionLimitUnset$()
			.pipe(
				filter((isUnset) => !isUnset),
				tap(() => this.dialogLayout.close())
			)
			.subscribe();
	}

	onNavigate() {
		this.dialogLayout.close();
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}
}
